(() => {
  if (window.Shopify?.designMode) return;

  const hiddenTitles = ['Still looking?', 'New T-shirts are here', 'Come back to So Called Clothing'];
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  let visibleTitle = document.title;
  let timer = 0;
  let index = 0;

  const restore = () => {
    window.clearInterval(timer);
    timer = 0;
    index = 0;
    document.title = visibleTitle;
  };

  const update = () => {
    document.title = hiddenTitles[index % hiddenTitles.length];
    index += 1;
  };

  const handleVisibilityChange = () => {
    if (!document.hidden) {
      restore();
      visibleTitle = document.title;
      return;
    }

    visibleTitle = document.title;
    update();
    if (!reduceMotion) timer = window.setInterval(update, 4000);
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('pagehide', restore, { once: true });
})();
